import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Avatar from '@material-ui/core/Avatar';
import { auth, db } from '../settings/firebase';
import PostBody from '../components/PostBody';
import Footer from '../components/Footer';
import NoImg from '../img/noimg.jpg';
import './MyProfile.css';
import { Link } from 'react-router-dom';
import Follow from '../components/Follow';
import FollowList from '../components/FollowList';

const cardContents = [
  {
    docId: "test0",
    title: "",
    description: "",
    comment: "",
    recommender: "",
    avatarUrl: NoImg,
    thumbnail: NoImg,
  }
]

const defaultuser = {
  avatarUrl: "",
  favorite: [],
  username: "",
  displayid: "",
}

class ItemList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {list: cardContents, tabValue: this.props.tab,
      editoruid: this.props.editoruid, bookid: this.props.bookid};
    this.componentDidMount = this.componentDidMount.bind(this);
  }
  _isMounted = false; //unmountを判断（ローディング判定用）

  // 最初に読み込むときに行う
  async componentDidMount() {
    // 現在のユーザのUIDを取得
    let editorid = this.props.editoruid;
    await db.collection("displayids").doc(this.props.editoruid).get().then(async (doc) => {
      if (doc.exists) {
        editorid = doc.data().uid;
      }
    })
    // console.log(editorid);
    // Firestoreからデータ一覧を取得する
    let articlesDb = db.collection("items");
    let nowuser = this.props.nowuser;

    if (this.state.tabValue === 0) {
      articlesDb = articlesDb.where("recommender", "==", editorid);
    } else if (this.state.tabValue === 2) {
      articlesDb = articlesDb.orderBy('star', 'desc').where("star", ">", 0);
    }

    const articlesSnapshot = await articlesDb.orderBy('createdAt', 'desc').get()
    const items = [];
    articlesSnapshot.forEach(async doc => {
      let data = doc.data();
      // console.log(data)
      let add = false;
      if (this.state.tabValue === 0) { //投稿
        add = true;
      } else if (this.state.tabValue === 1) { //いいね
        // console.log(this.props.editoruid)
        data.like.forEach(likeuser => {
          if (likeuser.uid === editorid) {
            add = true;
          }
        })
      } else if (this.state.tabValue === 2) { //コレクト
        nowuser.favorite.forEach(fav => {
          if (fav.pid === doc.id) {
            add = true;
          }
        })
      }

      if (add) {
        data.docId = doc.id;
        if(data.thumbnail.length === 0) {
          data.thumbnail = NoImg;
        }
        await db.collection("users").onSnapshot((snapshot) => {
          snapshot.forEach(userdoc => {
            if(userdoc.id === data.recommender) {
              data.avatarUrl = userdoc.data().avatarUrl;
              data.username = userdoc.data().name;
              data.displayid = userdoc.data().displayid;
              this.setState({ loading: true }); //ローディングしたらレンダーを呼び出す
            }
          });
        })
        items.push(data);
      }
    });
    this.setState({ list: items });

    nowuser.favorite.forEach(fav => {
      let favexists = false;
      if(items.length === 0) {
        favexists = true;
      }
      for(let index = 0; index < items.length; index++) {
        if(fav.pid === items[index].docId) {
          favexists = true;
        }
      }

      if (!favexists) {
        const userdoc = db.collection("users").doc(nowuser.uid);
        db.runTransaction((transaction) => {
          transaction.get(userdoc).then(doc => {
            if (!doc.exists) {
              throw "Document does not exist!";
            }
            let newfavorite = doc.data().favorite;
            for(let favi = 0; favi < newfavorite.length; favi++) {
              if (newfavorite[favi].pid === fav.pid) {
                newfavorite.splice(favi, 1);
                break;
              }
            }
            transaction.update(userdoc, { favorite: newfavorite });
          })
        })
      }
    })

    this._isMounted = true;
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  render() {
    let list = this.state.list;
    let listItems = []
    for ( const itemdata of list) {
      listItems.push(<PostBody key={itemdata.docId} data={itemdata} />)
    }
    return(
      <>{listItems}</>
    )
  }
}

class MyProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {tabValue: 0, editor: this.props.match.params.userid, editoruid: "", profile: "",
      avatarUrl: "", name: "", follow: 0, follower: 0, collectnum: 0, bookid: "",
      iseditor: false, nowuser: defaultuser, status: false, showPopup: false, modaltype: "",
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.changeIndex = this.changeIndex.bind(this);
    this.togglePopupFollow = this.togglePopupFollow.bind(this);
    this.togglePopupFollower = this.togglePopupFollower.bind(this);
  }
  _isMounted = false; //unmountを判断（ローディング判定用）

  // 最初に読み込むときに行う
  async componentDidMount() {
    await db.collection("displayids").doc(this.state.editor).get().then(async (doc) => {
      if (doc.exists) {
        let editorid = doc.data().uid;
        let iseditor = false;
        // 現在のユーザのUIDを取得
        let uid = "";
        let editorProf = {};
        await auth.onAuthStateChanged(async user => {
          uid = "";
          if (user) {
            uid = user.uid;
          }
          let nowuser = {}
          await db.collection("users").onSnapshot((snapshot) => {
            snapshot.forEach(userdoc => {
              if(userdoc.id === uid) {
                nowuser.uid = uid;
                nowuser.avatarUrl = userdoc.data().avatarUrl;
                nowuser.username = userdoc.data().name;
                nowuser.displayid = userdoc.data().displayid;
                nowuser.favorite = userdoc.data().favorite;
                this.setState({nowuser: nowuser});
              }
              if (userdoc.id === editorid) {
                editorProf.avatarUrl = userdoc.data().avatarUrl;
                editorProf.name = userdoc.data().name;
                editorProf.profile = userdoc.data().intro;
                editorProf.follow = userdoc.data().follow;
                editorProf.follower = userdoc.data().follower;
                editorProf.collectNum = userdoc.data().favorite.length;
                // もし自分のページの場合
                if (editorid === uid) {
                  iseditor = true;
                }
                // console.log(editorProf)
                this.setState({editoruid: editorid, iseditor: iseditor,
                  avatarUrl: editorProf.avatarUrl, name: editorProf.name,
                  follow: editorProf.follow, follower: editorProf.follower,
                  collectnum: editorProf.collectNum, profile: editorProf.profile}
                );
              }
            });
          })
        });
      } else {
        console.log("このアカウントは存在しません。");
      }
    }).catch(error => {
      console.log("このアカウントは存在しません。", error);
    });

    this._isMounted = true;
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  changeTab(e, newValue) {
    this.setState({tabValue: newValue});
  }

  changeIndex(index) {
    this.setState({tabValue: index});
  }

  // モーダルでリスト表示
  togglePopupFollow() {
    this.setState({ showPopup: !this.state.showPopup, modaltype: "follow" });
  }
  togglePopupFollower() {
    this.setState({ showPopup: !this.state.showPopup, modaltype: "follower" });
  }

  render() {
    return (
      <>
        <div style={{display: "flex", alignItems: "center", margin: "1em", flexWrap: "wrap"}}>
          <Avatar style={{width: "56px", height: "56px"}} alt={this.state.editor} src={this.state.avatarUrl} />
          <div style={{display: "flex", alignItems: "center", flexWrap: "wrap"}}>
            <span style={{paddingLeft: ".5em", fontSize: "24px", fontWeight: "700"}}>
              {this.state.name}
            </span>
            <span style={{paddingLeft: ".5em", color: "#999999"}}>
              @{this.state.editor}
            </span>
          </div>
          <div style={{display: "flex", flexGrow: "1"}}></div>
          <div className={"mypagerightbtn"}></div>
        </div>
        <div className={"mypageprofile"}>{this.state.profile}</div>
        <div style={{display: "flex", alignItems: "center", flexWrap: "wrap"}}>
          <div className={"mypagefollowcount"} onClick={this.togglePopupFollow}>
            <div className={"mypagecountnum"}>{this.state.follow}</div>
            <div className={"mypagecountlabel"}>フォロー</div>
          </div>
          <div className={"mypagefollowcount"} onClick={this.togglePopupFollower}>
            <div className={"mypagecountnum"}>{this.state.follower}</div>
            <div className={"mypagecountlabel"}>フォロワー</div>
          </div>
          {this.state.showPopup? <FollowList closelist={this.togglePopupFollow} type={this.state.modaltype} uid={this.state.editoruid} />: null}
          {this.state.iseditor? <div className={"mypagefollowcount"}>
            <div className={"mypagecountnum"}>{this.state.collectnum}</div>
            <div className={"mypagecountlabel"}>コレクト</div>
          </div>
          : null}
          <div style={{display: "flex", flexGrow: "1"}}></div>
          <div className={"mypagerightbtn"}>
            {this.state.iseditor?
              <Link style={{borderRadius: "20px", textDecoration: "none", textAlign: "center",
                padding: "7px", width: "9em", fontFamily: "Roboto", fontWeight: "600",
                boxShadow: "0 1px 2px #555555", backgroundColor: "#e6cf7e",
                color: "#222222", margin: "0em 2em 1em 0em",
                '&:hover': {cursor: "pointer", textDecoration: "none", backgroundColor: "#e6cf7e"}}}
                to={"/settings"}
              >プロフィールを編集</Link>
            :
              <Follow followuid={this.state.editoruid} />
            }
          </div>
        </div>
        <AppBar position="static" className={"homeBar"}>
          <Tabs
            value={this.state.tabValue}
            onChange={this.changeTab}
            className={"myProfileBar"}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="tabs label"
          >
            <Tab label="投稿" id="tab00-label" aria-controls="tab00" className={"myProfileBarText"} />
            <Tab label="いいね" id="tab01-label" aria-controls="tab01" className={"myProfileBarText"} />
            {this.state.iseditor? <Tab label="コレクト" id="tab02-label" aria-controls="tab02" className={"myProfileBarText"} />
            : null}
          </Tabs>
        </AppBar>
        <SwipeableViews
          index={this.state.tabValue}
          onChangeIndex={this.changeIndex}
        >
          <div role="tabpanel" id="tab00" index={0} aria-labelledby="tab00-label" style={{display: "flex", flexWrap: "wrap"}}>
            <ItemList tab={0} editoruid={this.state.editor} bookid={this.state.bookid} nowuser={this.state.nowuser} />
          </div>
          <div role="tabpanel" id="tab01" index={1} aria-labelledby="tab01-label" style={{display: "flex", flexWrap: "wrap"}}>
            <ItemList tab={1} editoruid={this.state.editor} bookid={this.state.bookid} nowuser={this.state.nowuser} />
          </div>
          {this.state.iseditor? <div role="tabpanel" id="tab02" index={2} aria-labelledby="tab02-label" style={{display: "flex", flexWrap: "wrap"}}>
            <ItemList tab={2} editoruid={this.state.editor} bookid={this.state.bookid} nowuser={this.state.nowuser} />
          </div>
          : null}
        </SwipeableViews>
        <Footer page="mypage" />
      </>
    )
  }
}

export default MyProfile;